module.exports = __webpack_public_path__ + "static/media/logo-black.5f508977.png";